import type { ReactNode } from 'react';

export const symbol_calendar_clock: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-630h600v-130H180v130Zm0 0v-130 130Zm0 550q-24 0-42-18t-18-42v-620q0-24 18-42t42-18h65v-28q0-13.6 9.48-22.8 9.48-9.2 23.5-9.2t23.02 9.2q9 9.2 9 22.8v28h340v-28q0-13.6 9.48-22.8 9.48-9.2 23.5-9.2t23.02 9.2q9 9.2 9 22.8v28h65q24 0 42 18t18 42v277q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-87H180v430h306q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q498.75-80 486-80H180Zm417.5-15.5Q542-151 542-229t55.5-133.5Q653-418 731-418t133.5 55.5Q920-307 920-229T864.5-95.5Q809-40 731-40T597.5-95.5ZM742-231v-92.92q0-8.08-5.5-13.58T723-343q-8 0-14 5.7t-6 13.3v95q0 5.57 2 10.78 2 5.22 6 10.22l64 66q6 6 14 6t14-6q6-6 6-14t-6-14l-61-61Z"
		/>
	</svg>
);
